import { Styles } from '@monkvision/types';

export const styles: Styles = {
  counter: {
    display: 'flex',
    color: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
    margin: '0 10px',
    whiteSpace: 'nowrap',
    borderRadius: 8,
    zIndex: 9,
  },
};
